import flatten from "lodash/flatten";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

import prepareKeywords from "./prepare_keywords";

// getSearchActivityModel creates an activity ready to be fetched
// it might return null in some circumstances

const getHash = (arr) => arr.map((item) => `${item.id}:${item.importance}`).sort();

const getSearchActivityModel = ({
  term,
  searchActivity,
  searchActivityId,
  choosenKeywords,
  deletedKeywords
}) => {
  const { activityCustomFields } = prepareKeywords(choosenKeywords, deletedKeywords);
  let needsASave = true;
  const searchActivityModel = {
    state: "search",
    description: (term || "").trim(),
    communication_type: "group"
  };

  if (searchActivityId) {
    searchActivityModel.id = searchActivityId;
  }

  // fetch could be trigger not only by a race condition but also by an update of the
  // searchActivity (that carries custom_fields or filters - TBD: should update of searchActivity
  // update the term as well (description -> term)) basically if the most recent
  // searchActivity props agree with local state then there is no need to fetch.
  if (searchActivity) {
    const stateKeywordsHash = getHash(choosenKeywords);
    const activityKeywordsHash = getHash(flatten(searchActivity.custom_fields.map(({ values }) => values)));

    const sameKeywords = isEqual(stateKeywordsHash, activityKeywordsHash);
    const sameTerm = searchActivity.description.trim() === term.trim();

    if (sameKeywords && sameTerm) {
      needsASave = false;
    }

    // Only submit custom_fields to API if it was loaded before for removing
    searchActivityModel.custom_fields = activityCustomFields;
  } else if (!isEmpty(activityCustomFields)) {
    searchActivityModel.custom_fields = activityCustomFields;
  }

  return [searchActivityModel, needsASave];
};

export default getSearchActivityModel;
